// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page-container-IG2dK {
  padding: 40px;
}

.error-page-image-YV5Om {
  display: block;
  width: 100%;
  max-width: 360px;
  margin: 32px auto 0px;
}

.error-page-title-Em1Tf {
  color: rgba(0, 0, 0, 0.9);
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin: 24px 0px 0px;
  padding: 0px 12px;
}

.error-page-description-dYtCB {
  font-size: 16px;
  font-weight: 100;
  text-align: center;
  margin-top: 24px;
  line-height: 1.5;
}

.error-page-whatsappLink-_nBZU {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(3px);
  gap: 4px;
  text-decoration: none;
  line-height: 1;
  margin-left: 6px;
}

.error-page-whatsappIcon-DHL8Y {
  width: 18px;
  height: 18px;
  fill: currentColor;
}

.error-page-button_base-qRJmV {
  width: 100%;
  height: 40px;
  max-width: 340px;
  margin: 40px auto;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/error-page/error-page.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".container {\n  padding: 40px;\n}\n\n.image {\n  display: block;\n  width: 100%;\n  max-width: 360px;\n  margin: 32px auto 0px;\n}\n\n.title {\n  color: rgba(0, 0, 0, 0.9);\n  font-size: 18px;\n  font-weight: 500;\n  text-align: center;\n  margin: 24px 0px 0px;\n  padding: 0px 12px;\n}\n\n.description {\n  font-size: 16px;\n  font-weight: 100;\n  text-align: center;\n  margin-top: 24px;\n  line-height: 1.5;\n}\n\n.whatsappLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(3px);\n  gap: 4px;\n  text-decoration: none;\n  line-height: 1;\n  margin-left: 6px;\n}\n\n.whatsappIcon {\n  width: 18px;\n  height: 18px;\n  fill: currentColor;\n}\n\n.button_base {\n  width: 100%;\n  height: 40px;\n  max-width: 340px;\n  margin: 40px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `error-page-container-IG2dK`,
	"image": `error-page-image-YV5Om`,
	"title": `error-page-title-Em1Tf`,
	"description": `error-page-description-dYtCB`,
	"whatsappLink": `error-page-whatsappLink-_nBZU`,
	"whatsappIcon": `error-page-whatsappIcon-DHL8Y`,
	"button_base": `error-page-button_base-qRJmV`
};
export default ___CSS_LOADER_EXPORT___;
